import React from 'react';
import styled from 'styled-components';

interface ICloseButton {
  className: string;
  onClick: () => void;
}

export const CloseButton: React.FC<ICloseButton> = ({ className, onClick }) => {
  return (
    <StyledIcon className={className} onClick={onClick}>
      <svg
        width="22"
        height="20"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 2L13.5 13.5M25 25L13.5 13.5M13.5 13.5L25 2L2 25"
          stroke="white"
          strokeWidth="3.45"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </StyledIcon>
  );
};

const StyledIcon = styled.div`
  &:hover {
    cursor: pointer;
  }
`;
